var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.860352,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1C202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3307 16.8604C20.1854 16.8604 16 21.0496 16 26.1963V39.5296C16 44.675 20.1893 48.8604 25.3359 48.8604H38.6693C43.8146 48.8604 48 44.6711 48 39.5244V26.1911C48 21.0457 43.8107 16.8604 38.6641 16.8604H25.3307ZM41.3333 22.1937C42.0693 22.1937 42.6667 22.791 42.6667 23.527C42.6667 24.263 42.0693 24.8604 41.3333 24.8604C40.5973 24.8604 40 24.263 40 23.527C40 22.791 40.5973 22.1937 41.3333 22.1937ZM32 24.8604C36.412 24.8604 40 28.4484 40 32.8604C40 37.2724 36.412 40.8604 32 40.8604C27.588 40.8604 24 37.2724 24 32.8604C24 28.4484 27.588 24.8604 32 24.8604ZM32 27.527C30.5855 27.527 29.229 28.0889 28.2288 29.0891C27.2286 30.0893 26.6667 31.4459 26.6667 32.8604C26.6667 34.2748 27.2286 35.6314 28.2288 36.6316C29.229 37.6318 30.5855 38.1937 32 38.1937C33.4145 38.1937 34.771 37.6318 35.7712 36.6316C36.7714 35.6314 37.3333 34.2748 37.3333 32.8604C37.3333 31.4459 36.7714 30.0893 35.7712 29.0891C34.771 28.0889 33.4145 27.527 32 27.527Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLogo);
export default __webpack_public_path__ + "static/media/instaLogo.93e3ce8a5fa18fa0f9dd840aa94f7f1b.svg";
export { ForwardRef as ReactComponent };